import { render, staticRenderFns } from "./editpwd.vue?vue&type=template&id=7d98090d&scoped=true&%3Ais=view&"
import script from "./editpwd.vue?vue&type=script&lang=js&"
export * from "./editpwd.vue?vue&type=script&lang=js&"
import style0 from "./editpwd.vue?vue&type=style&index=0&id=7d98090d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d98090d",
  null
  
)

export default component.exports